/* Copyright (c) 2022-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { theme, FlexContainer } from "@nordcloud/gnui";

export const DetailsItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.spacing03};
`;

export const DetailsTitle = styled(FlexContainer)`
  word-break: break-all;
  color: ${theme.color.text.text02};
  font-size: ${theme.fontSizes.sm};
  line-height: 1rem;
`;

export const DetailsDescription = styled.div`
  display: flex;
  align-items: center;
  word-break: break-all;
  white-space: pre-wrap;
  width: 100%;
`;

export const ValueWrapper = styled.div<{ editable: boolean; isEmpty: boolean }>`
  position: relative;
  display: flex;
  word-break: break-all;

  ${({ editable }) => editable && EditableUnderline}

  color: ${({ isEmpty }) =>
    isEmpty ? theme.color.text.text02 : theme.color.text.text01};
`;

const EditableUnderline = css<{ isEmpty: boolean }>`
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-thickness: 1px;
  text-decoration-color: ${({ isEmpty }) =>
    isEmpty ? theme.color.text.text02 : theme.color.text.text01};
  text-underline-offset: ${theme.spacing.spacing01};
`;

export const DetailWrapper = styled(FlexContainer)`
  width: fit-content;

  :hover > Button {
    visibility: visible;
  }

  &:hover ${ValueWrapper} {
    text-decoration: none;
  }
`;
